import * as Yup from 'yup';

import { Strings } from '@app/constants';

// ---------------addCategorySchema-------------
export const addCategorySchema = Yup.object()
  .shape({
    name: Yup.string().required(Strings.validation.fieldRequired(Strings.field.name)),
    image: Yup.string().required(Strings.validation.uploadRequired(Strings.field.image)),
    type: Yup.string().required(Strings.validation.selectRequired(Strings.field.type)),
  })
  .required();
